module.exports = __webpack_public_path__ + "static/media/Why choose us bg.cd36f2da.png";